import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    newPlayers: [],
    trendingPlayers: [],
    trendingEvoPlayers: [],
    trendingSbcIds: [],
};
/**
 * The rows each front-page feed last showed, so switching feeds paints on the
 * first frame instead of flashing skeletons. No staleness policy: every mount
 * still fetches. Named `frontPageFeeds` because web has its own `frontPageSlice`.
 */
const frontPageFeedsSlice = createSlice({
    name: "frontPageFeeds",
    initialState,
    reducers: {
        newPlayersLoaded: (state, action) => {
            state.newPlayers = action.payload;
        },
        trendingLoaded: (state, action) => {
            state.trendingPlayers = action.payload.players;
            state.trendingEvoPlayers = action.payload.evoPlayers;
        },
        trendingSbcsLoaded: (state, action) => {
            state.trendingSbcIds = action.payload;
        },
    },
});
export const { newPlayersLoaded, trendingLoaded, trendingSbcsLoaded } = frontPageFeedsSlice.actions;
export const frontPageFeedsSelector = (state) => state.frontPageFeedsReducer;
export default frontPageFeedsSlice.reducer;
//# sourceMappingURL=frontPageFeedsSlice.js.map